import { connect } from 'react-redux';

import ChatInvite from './';
import { addUsersToChannel } from "../../actions/chatActions";

const mapStateToProps = (state, ownProps) => {
  const chatId = ownProps.match.params.chatId;
  const chat = state.chats[chatId];
  return {
    chat
  }
};

const mapDispatchToProps = dispatch => ({
  addUsersToChannel: (chatId, userIds) => dispatch(addUsersToChannel(chatId, userIds))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatInvite);